import React from 'react'
import { MetaData } from 'components/MetaData'
import { FadeIn, Spinner, EmptyContainer } from 'lib/ui'
import { useBlog } from 'hooks/blog'
import { useBlogConfig } from 'lib/core/hooks'
import allPostsImage from 'resources/images/livbrite-blog-all.jpg'
import { CategoryTile } from '../../components/CategoryTile'
import { Grid } from './components/Styled'

export const Index = () => {
  const { categoryList } = useBlog()
  const { config, loading } = useBlogConfig()

  if (loading) {
    return (
      <>
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      </>
    )
  }

  return (
    <>
      {config && (
        <MetaData
          title={config?.getBlogConfig.meta_title}
          description={config?.getBlogConfig.meta_description}
          keywords={config?.getBlogConfig.meta_keywords}
        />
      )}
      <FadeIn>
        {!categoryList ? (
          <Spinner />
        ) : (
          <Grid>
            {categoryList.map((category: any) => {
              const {
                id,
                name,
                category_blog_thumbnail: image,
                url_key: slug
              } = category
              const categoryImage = image !== '' ? image : allPostsImage
              return (
                <div key={id}>
                  <CategoryTile
                    image={categoryImage}
                    title={name}
                    link={`/blog/category/${slug}`}
                  />
                </div>
              )
            })}
          </Grid>
        )}
      </FadeIn>
    </>
  )
}
